import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentMethodsComponent from './paymentmethods-component';
import AccountInformationComponent from './account-information-component';
import PasswordReset from '../../global/reset-password-component';
import RenterOwnerComponent from './renter-owner-component';

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

class DashboardAccountComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRenterToOwnerModal: false
    }
    this.openRenterToOwnerModal = this.openRenterToOwnerModal.bind(this);
    this.closeRenterToOwnerModal = this.closeRenterToOwnerModal.bind(this);
  }

  componentDidUpdate(oldProps) {
  }

  openRenterToOwnerModal() {
    this.setState({ showRenterToOwnerModal: true });
  }
  closeRenterToOwnerModal() {
    this.setState({ showRenterToOwnerModal: false });
  }


  render() {
    let { dashboard, global } = this.props;
    let { showRenterToOwnerModal } = this.state;
    let user = dashboard.user;
    if (!user) { return (<div>Loading...</div>) }
    return (
      <div className="container account-container mb-5">
        <h1>Account Information</h1>
        <hr />
        <AccountInformationComponent />
        <h2 className="mt-4">Change Password</h2>
        <hr />
        <PasswordReset />
        <h2 className="mt-4">Payment Methods</h2>
        <hr />
        <PaymentMethodsComponent />
        {user.userType === 'renter' && (<div className="renterToOwner">Looking to become a CollegeWeekends.com owner and list a property?
          <a onClick={this.openRenterToOwnerModal} tabIndex='7' >Click Here!</a></div>)}
        {showRenterToOwnerModal && <RenterOwnerComponent user={user} onClose={this.closeRenterToOwnerModal} errors={global.errors} />}
      </div>);

  }
}

export default connect(mapStateToProps)(DashboardAccountComponent);
